<template>
    <vs-sidebar :click-not-close="clickNotClose"
        :hiddenBackground="hiddenBackground" 
        default-index="-1"  
        color="primary" :reduce="reduce"
        :reduce-not-rebound="true"
        class="sidebarx" spacer 
        v-model="isVerticalNavMenuActive">
        <div class="wrap-sidebar" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
                <a href="javascript:void(0)" class="handle-menu cursor-pointer" v-if="!mobileMenu">
                    <feather :type="reduce ? 'circle' : 'disc'" @click="toggleReduce(!reduce)" />
                </a>
                <a href="javascript:void(0)" class="handle-menu cursor-pointer" v-if="mobileMenu">
                    <feather type="x" @click="closeMenu()" />
                </a>
                <div class="header-sidebar" slot="header">
                    <vs-avatar :src="userInfoData.profileUrl"/>
                    <span class="user-name">{{ userInfoData.username }}</span>
                    <span class="logout" @click="logout"><feather type="log-out" /></span>
                    <router-link to="/profile" class="profile"><feather type="edit-2"></feather></router-link>
                </div>
                <vs-sidebar-item index="1" icon="home" to="/" v-if="userInfoData.role != Roles.Warehouse">
                    Inicio
                </vs-sidebar-item>
                <vs-sidebar-item index="2" icon="people_alt"  to="/clients" v-if="userInfoData.role === Roles.Admin">
                    Clientes
                </vs-sidebar-item>
                <!-- <vs-sidebar-item index="11" icon="attach_money"  to="/cashback" v-if="userInfoData.customerType === '03'">
                    Cashback
                </vs-sidebar-item> -->
                <vs-sidebar-item index="4" icon="assignment" to="/packages" v-if="userInfoData.role != Roles.Warehouse && userInfoData.customerType != '03'">
                    Paquetes
                </vs-sidebar-item>
                <vs-sidebar-item index="10" icon="library_add" to="/pre-alert" v-if="userInfoData.role === Roles.Customer && userInfoData.customerType != '03'">
                    Pre Alertar
                </vs-sidebar-item>
                <vs-sidebar-item index="5" icon="bookmark" to="/taxes" v-if="userInfoData.role === Roles.Admin">
                    Aranceles
                </vs-sidebar-item>
                <vs-sidebar-item index="15" icon="location_on" to="/address" v-if="userInfoData.role != Roles.Warehouse">
                    Tu dirección en Miami
                </vs-sidebar-item>
                <vs-sidebar-item index="20" icon="people_alt" to="/memberships" v-if="userInfoData.customerType === '03'">
                    Afiliados
                </vs-sidebar-item>
                
                <vs-sidebar-item index="21" icon="attach_money" to="/cashback/summary" v-if="userInfoData.customerType === '03'">
                    CashBox
                </vs-sidebar-item>

                <vs-sidebar-item index="28" icon="assignment" to="/inventories"  v-if="userInfoData.role === Roles.Admin">
                    Inventario
                </vs-sidebar-item>

                
                <vs-sidebar-item index="40" icon="assignment" to="/inventory/add"  v-if="userInfoData.role === Roles.Warehouse">
                    Agregar Inventario
                </vs-sidebar-item>

                <vs-sidebar-item index="89" icon="book" to="/inventories"  v-if="userInfoData.role === Roles.Warehouse">
                    Inventario
                </vs-sidebar-item>

                <vs-sidebar-item index="29" icon="book" to="/orders"  v-if="userInfoData.role === Roles.Admin || userInfoData.role === Roles.Warehouse">
                    Órdenes despacho
                </vs-sidebar-item>

                <vs-sidebar-item index="70" icon="local_shipping" to="/routes" v-if="userInfoData.role === Roles.Admin">
                    Rutas
                </vs-sidebar-item>
                
                <vs-sidebar-item index="23" icon="account_box" to="/admin/memberships" v-if="userInfoData.role === Roles.Admin">
                    Membresías
                </vs-sidebar-item>

                <vs-sidebar-item index="75" icon="account_tree" to="/operations" v-if="userInfoData.role === Roles.Admin">
                    Operaciones
                </vs-sidebar-item>

                <vs-divider position="center" v-if="userInfoData.role === Roles.Admin">
                    Configuración
                </vs-divider>
                
                <vs-sidebar-item index="7" icon="account_box" to="/users" v-if="userInfoData.role === Roles.Admin">
                    Usuarios
                </vs-sidebar-item>
                
                <vs-sidebar-item index="8" icon="account_tree" to="/customer-types" v-if="userInfoData.role === Roles.Admin">
                    Tipos de Clientes
                </vs-sidebar-item>
                
                <!-- <vs-sidebar-item index="13" icon="account_balance" to="/credits" v-if="userInfoData.role === Roles.Admin">
                    M&oacute;dulo de cr&eacute;dito
                </vs-sidebar-item>

                <vs-sidebar-item index="12" icon="trending_up" to="/credit-lines" v-if="userInfoData.role === Roles.Admin">
                    Lineas de cr&eacute;dito
                </vs-sidebar-item> -->

                <vs-sidebar-item index="14" icon="pie_chart" to="/reporte-ventas" v-if="userInfoData.role === Roles.Admin">
                    Reporte Ventas
                </vs-sidebar-item>

                <vs-sidebar-item index="30" icon="poll" to="/surveys" v-if="userInfoData.role === Roles.Admin">
                    Encuestas
                </vs-sidebar-item>

                <vs-sidebar-item index="22" icon="trending_up" to="/cashback/rates" v-if="userInfoData.role === Roles.Admin">
                    CashBox Rates
                </vs-sidebar-item>

                <vs-sidebar-item index="9" icon="business" to="/configuration" v-if="userInfoData.role === Roles.Admin">
                    Box Logistics
                </vs-sidebar-item>


              
        </div>
    </vs-sidebar>
</template>
<script>
import { Role } from '@/helpers/Role.js';
import { mapState, mapActions } from 'vuex'
export default {
  name: "sidebar",
  data () {
    return {
        Roles: {},
        hiddenBackground: true,
        isVerticalNavMenuActive: true,
        mobileMenu: false,
        clickNotClose       : true, // disable close navMenu on outside click
        isMouseEnter        : false,
        reduce              : false, // determines if navMenu is reduce - component property
        showCloseButton     : false, // show close button in smaller devices
        showShadowBottom    : false,
        currentUserObj: {},
    }
  },
  watch: {
    '$route' () {
      if (this.windowWidth < 1200 && this.showMenuMobile ) {
        this.updatedMenuActive(false)
      }
    },
    windowWidth ()  { this.checkWidthScreen() },
    statusMenu () { this.handleStatusMenu() },
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.user;   
    },
    ...mapState([
      'userInfoData'
    ]),
    windowWidth () { return this.$store.state.windowWidth },
    statusMenu () { return this.$store.state.navMenuActive },
  },
  created () {
    this.currentUserObj = this.currentUser
    this.Roles = Role
    this.isVerticalNavMenuActive = this.statusMenu
  },
  mounted (){
    this.checkWidthScreen()
  },
  methods: {
    ...mapActions([
      'showMenuMobile',
      'updatedMenuActive',
      'handleReduceMenu',
      'addUserInfo'
    ]),
    logout () {
      this.addUserInfo({})
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    toggleReduce (val) {
      this.reduce = val
      this.handleReduceMenu(val)
    },
    mouseEnter () {
      this.isMouseEnter = true
    },
    mouseLeave () {
      this.isMouseEnter = false
    },
    checkWidthScreen () {
      if (this.windowWidth < 1200) {
        this.mobileMenu = true
        this.reduce = false
        this.$emit('reduceButton', this.reduce)
        this.$emit('mobileMenu', this.mobileMenu)
        this.updatedMenuActive(false)
        this.showMenuMobile(true)
        this.hiddenBackground = false
      }else{
        //this.reduce = true
        this.mobileMenu = false
        this.$emit('mobileMenu', this.mobileMenu)
        this.hiddenBackground = true
        this.updatedMenuActive(true)
        this.showMenuMobile(false)        
      }
    },
    handleStatusMenu () {
      this.isVerticalNavMenuActive = this.statusMenu
    },
    closeMenu () {
       this.updatedMenuActive(!this.isVerticalNavMenuActive)
    }
  }
}
</script>